<template>
  <div class="ion-page">
    <ion-header no-border>
      <ion-toolbar>
        <ion-title>
          <!-- <div id="site-logo"></div> -->
        </ion-title>
    <ion-menu-toggle auto-hide="false">
        <router-link style="text-decoration: none;" to="/profile" v-if="$store.state.user.user.email">
          <ion-item lines="none">
            <div>
              <div class="profile-widget-container">
                <div class="profile-widget-photo">
                  <ion-avatar>
                    <img :src="$store.state.user.user.photoUrl" />
                  </ion-avatar>
                </div>
                <div class="profile-widget-item">
                    <p class="profile-widget-item-name">
                      {{ $store.state.user.user.name }}
                    </p>
                    <p style="margin: 0;">
                      {{ username }}
                    </p>
                </div>
              </div>
            </div>
          </ion-item>
        </router-link>
    </ion-menu-toggle>

        <router-link  class="ion-menu-item" activeClass="ion-menu-item-active" to="/profile/login" v-if="!$store.state.user.user.email">
          <ion-item lines="none" detail="false" class="ion-menu-item-button" button>
            <ion-icon color="primary" slot="start" name="log-in"></ion-icon>
            <ion-label>
              Login
            </ion-label>
          </ion-item>
        </router-link>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-list lines="none">
        <!--
        <ion-list-header>
          Navigate
        </ion-list-header>
      -->

        <ion-menu-toggle auto-hide="false">
          <!-- dynamic menu items -->
          <component
            :is="item.route ? 'router-link' : 'div'"
            :to="item.route"
            v-for="(item, idx) in menuItems"
            :key="idx"
            class="ion-menu-item"
            activeClass="ion-menu-item-active"
          >
              <ion-item detail="false" class="ion-menu-item-button" button @click="menuItemClicked(item)">
                <ion-icon
                  color="primary"
                  slot="start"
                  :name="item.icon"
                ></ion-icon>
                <ion-label>
                  {{ item.title }}
                </ion-label>
              </ion-item>
          </component>

          <ion-item detail="false" class="ion-menu-item-button" v-if="$store.state.user.user.email" button @click="logout">
            <ion-icon
              color="primary"
              slot="start"
              name="exit"
              @click="logout"
            ></ion-icon>
            <ion-label>
              Logout
            </ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
    </ion-content>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },

  computed: {
    menuItems() {
      return this.$store.state.ui.menu || [];
    },
    username() {
      return (this.$store.state.user.user.email || "").split("@")[0];
    }
  },

  methods: {
    logout() {
      delete this.$http.defaults.headers.common["Authorization"];

      //lazy load firebase
      import(/* webpackChunkName: "logout" */'@/firebase')
      .then($firebase => {
        $firebase.firebase.auth().signOut();
      });

      this.$store.commit("user/setUser", null);
      this.$ionic.showToast(
        "You have been logged out.",
        {
          duration: 3500,
          position: "bottom"
        }
      );

      if(this.$route.path !== '/dashboard') {
        this.$router.push("/dashboard");
      }
    },

    menuItemClicked(item) {
      if (item.emit) {
        this.$root.$emit(item.emit, item);
      }
    }
  }
};
</script>
<style>
#site-logo {
  /*border: 2px solid red;*/
  background-position: center center;
  background-image: url("/img/logo.webp");
  background-repeat: no-repeat;
  background-size: 80%;
  height: 80px;
}

.ion-menu-item {
  text-decoration: none;
}

.ion-menu-item-button {
  --padding-top: 0.5em;
  --padding-bottom: 0.5em;
}

.ion-menu-item-active .ion-menu-item-button{
  --background: rgba(0, 0, 0, 0.103);
}

.profile-widget-container {
  margin: 10px 0;
  width: 100%;
  display: flex;
}

.profile-widget-photo {
  padding: 1em 0.2em;
}

.profile-widget-item {
  padding: 1em 1em 1em;
}

.profile-widget-item-name {
  font-weight: 600;
  font-size: 1.2em;
  white-space: initial;
  text-decoration: none;
  margin: 0;
}
</style>
